// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__3KTVj","title":"Info_title__9x4Ej","links":"Info_links__26OHd","link":"Info_link__BzqOm","logo":"Info_logo__1kGrw"};